const heapro = [
	'ជំងឺរាគរូស',
	'ជំងឺគ្រុនឈាម',
	'ជំងឺគ្រុនចាញ់',
	'ពស់ខាំ',
	'លង់ទឹក',
	'ជំងឺផ្សេងទៀត'
]
const firstAidLabel = [
	'តើសាលារៀនមានប្រអប់សង្រ្គោះបឋម ឬទេ?',
	'តើសាលារៀនមានបុគ្គលិកដែលបានទទួលការបណ្តុះបណ្តាលផ្នែកសង្រ្គោះបឋមឬទេ ?'
]
const recoverLabel = [
	'សាលារៀនមានផែនការគ្រប់គ្រងគ្រោះមហន្តរាយ និងផែនការកាត់បន្ថយហានិភ័យ ឬក៏កម្មវិធី ណាមួយសម្រាប់ទប់ទល់នឹងគ្រោះមហន្តរាយនេះឬទេ?',
	'តើសាលារៀនបានអនុវត្តផែនការកាត់បន្ថយគ្រោះមហន្តរាយ និងហានិភ័យឬទេ?',
	'តើសាលារៀនមានកន្លែងសម្រាប់បន្តការរៀនសូត្ររបស់សិស្សទេ ពេលមានគ្រោះមហន្តរាយធម្មជាតិម្តងៗ?',
	'តើសាលារៀនមានប្រភពទឹកផ្សេងទៀតប្រើប្រាស់ជំនួសទេ ​ពេលប្រព័ន្ធទឹកស្អាតត្រូវបានបំផ្លាញដោយគ្រោះមហន្តរាយ?',
	'តើសាលារៀនមានប្រព័ន្ធសម្រាប់កាត់បន្ថយកំដៅឬទេ នៅពេលអាកាសធាតុក្តៅខ្លាំងកើតមានឡើង?',
	'តើសាលារៀនមានកម្មវិធីឲ្យកូនសិស្សដាំដើមឈើឡើងវិញឬទេ?',
	'តើសាលារៀនមានថាមពលអគ្គីសនី ដើរដោយប្រព័ន្ធពន្លឺព្រះអាទិត្យ (Solar Power) ឬទេ?',
	'បើមាន តើវាគ្រប់គ្រាន់សម្រាប់យកមកប្រើប្រាស់តាមសេចក្តីត្រូវការរបស់សាលារៀនបានដែរឬទេ? (ប្រភព Solar)'
]
const fan_con = ['កង្ហាល់', 'ម៉ាស៊ីនត្រជាក់']
const ele_wat = ['ចំនួនថ្ងៃសរុបដែលសាលារៀនជួបប្រទះ']
const absentLabel = [
	'ពី២០ថ្ងៃដល់៤០ថ្ងៃ',
	'លើស៤០ថ្ងៃ'
]
const naturalLabel = [
	' គ្រោះរាំងស្ងួត',
	' ទឹកជំនន់',
	' ខ្យល់ព្យុះ/ខ្យល់កន្ត្រាក់',
	' ក្តៅជ្រុល(អាកាសធាតុឡើងកំដៅ)',
	' គ្រោះអគ្គីភ័យ',
	' ការឡើងកំពស់ ទឹកទន្លេ/សមុទ្រ',
	' ទឹកសមុទ្រហៀចូលទឹកសាប',
	' មូលហេតុផ្សេងទៀត'
]
const disasterLabel = [
	' គ្រោះរាំងស្ងួត',
	' ទឹកជំនន់',
	' ខ្យល់ព្យុះ/ខ្យល់កន្ត្រាក់',
	' ក្តៅជ្រុល(អាកាសធាតុឡើងកំដៅ)',
	' គ្រោះអគ្គីភ័យ',
	' ការឡើងកំពស់ ទឹកទន្លេ/សមុទ្រ',
	' ទឹកសមុទ្រហៀចូលទឹកសាប',
	' គ្រោះធម្មជាតិផ្សេងទៀត'
]
const waste_label = [
	' ប្រព័ន្ធបង្ហូរទឹកស្អុយ',
	' បរិក្ខារនៅនឹងកន្លែងដូចជា ធុងស្តុកទឹកស្អុយ ឬធុងចម្រោះទឹកស្អុយនៅក្រោមដី',
	' ឧបករណ៍រីសាយខល្លីងទឹកស្អុយ (Recycling: កែប្រែទឹកស្អុយទៅជាទឹកអាចប្រើប្រាស់បាន)',
	' កម្មវិធីកាត់បន្ថយកាកសំណល់',
	' ឧបករណ៏ផ្សេងទៀត'
]
const alternative_edu = [
	' កន្លែងរៀនបណ្តោះអាសន្ន នៅទីសុវត្ថិភាព',
	' ការរៀនតាមអនឡាយ ឬរៀនពីចម្ងាយ',
	' ការរៀនតាមវិទ្យុ ឬតាមទូរទស្សន៍'
]
const sch_fun = [
	' ថវិកា SOF ទទួលពីក្រសួងអប់រំ',
	' ថវិកាទទួលពីអាជ្ញាធរមូលដ្ឋាន',
	' ថវិកាទទួលពីសហគមន៍ និងមាតាបិតាសិស្ស',
	' ថវិកាទទួលពីអង្គការក្រៅរដ្ឋាភិបាល ឬដៃគូរអភិវឌ្ឍន៍',
	' ថវិកាទទួលពីប្រភពផ្សេងៗ',
	'សរុបថវិកា'
]
const material_demage = [
	' សៀវភៅគ្រូ',
	' សៀវភៅសិស្ស'
]
const yesNo = [
	{ value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.បាន' }, { value: 2, text: '២.មិនបាន' }
]
const yesNo2 = [
	{ value: 0, text: '០.ជ្រើសរើស' }, { value: 1, text: '១.មាន' }, { value: 2, text: '២.មិនមាន' }
]
export {
	firstAidLabel, recoverLabel, disasterLabel, fan_con, ele_wat,
	absentLabel, naturalLabel, waste_label, alternative_edu,
	sch_fun, material_demage, heapro,
	yesNo, yesNo2
}